import React from 'react';

import AppShell from '@/components/AppShell';
import routes from '@/pages/corporate/routes';

import Admin from './admin';

const AdminLayout = (page: React.ReactElement) => <Admin>{page}</Admin>;

const AppShellLayout = (page: React.ReactElement) => <AppShell>{page}</AppShell>;

const getDefaultLayout = (route: string) => {
  if (route.startsWith(routes.Admin())) {
    return AdminLayout;
  }

  return AppShellLayout;
};

export default getDefaultLayout;
